import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { settlementApi } from '../../../lib/api/settlement';
import {
  AdminExcelDownloadAcceptedResponseType,
  SettlementItemsFindAndDownloadExcelRequestBodySearchOptionsDto,
} from '../../../types/api/settlement-items';
import toastMsg from '../../../lib/toastMsg';
import { AxiosError } from 'axios';

export const useDownloadSettlementExcel = (
  request: SettlementItemsFindAndDownloadExcelRequestBodySearchOptionsDto,
): UseMutationResult<AdminExcelDownloadAcceptedResponseType, unknown, void, unknown> => {
  const mutate = useMutation({
    mutationFn: () => settlementApi.downloadSettlementItemsExcel({ searchOption: request }),
    onSuccess: ({ adminEmail }) => {
      toastMsg.success(`${adminEmail}로 엑셀이 발송되었습니다`);
    },
    onError: (error: AxiosError) => {
      toastMsg.success(`엑셀 발송에 실패했습니다. :${error.message}`);
    },
  });

  return mutate;
};
